<template>
  <div class="page-layout" :class="{ pc: !isPhone, phone: isPhone }">
    <van-nav-bar
      class="nav-bar"
      :class="{ 'hide-bg': !isPhone }"
      :left-arrow="leftArrow"
      :fixed="true"
      :placeholder="false"
      :border="!isPhone"
      :safe-area-inset-top="true"
      @click-left="onClickLeft"
      v-bind="$attrs"
      v-on="$listeners"
      v-if="showNavBar"
    >
      <template #[langChooseLocation]>
        <LangChoose v-show="isPhone && showLangChoose"></LangChoose>
      </template>
      <template #[navBarSlot]="slotProps" v-if="navBarSlot">
        <slot :name="navBarSlot" v-bind="slotProps"></slot>
      </template>
    </van-nav-bar>
    <div v-if="showNavBar" class="nav-bar-placeholder"></div>
    <slot></slot>
  </div>
</template>

<script>
import LangChoose from '../LangChoose.vue';
import { isPhone } from '@utiles/device';
import iframeMessage from '@mixins/officialSupport/iframeMessage';
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'PageLayout',
  mixins: [iframeMessage],
  props: {
    leftArrow: {
      type: Boolean,
      default: true
    },
    langChooseLocation: {
      type: String,
      default: 'right'
    },
    navBarSlot: {
      type: String,
      default: ''
    },
    clickLeft: {
      type: Function,
      default: null
    },
    showLangChoose: {
      type: Boolean,
      default: true
    },
    showNavBar: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isPhone: isPhone()
    };
  },
  computed: {
    ...mapGetters(['hasFaqClassList', 'hasWorkTempList']),
    ...mapState({
      isIframe: state => state.isIframe
    })
  },
  watch: {
    showLangChoose: {
      handler(val) {
        this.postMessageToParent('visibleLangChoose', val);
      },
      immediate: true
    }
  },
  methods: {
    onClickLeft() {
      if (this.clickLeft && typeof this.clickLeft === 'function') {
        this.clickLeft();
        return;
      }
      if (
        this.$route.name === 'mylist' &&
        (this.hasFaqClassList || this.hasWorkTempList)
      ) {
        this.$router.push({ name: 'workhome' });
        return;
      }
      if (this.isIframe) {
        this.postMessageToParent('goBack');
        return;
      }
      this.$router.go(-1);
    }
  },
  activated() {
    this.postMessageToParent('visibleLangChoose', this.showLangChoose);
  },
  components: {
    LangChoose
  }
};
</script>

<style lang="scss" scoped>
@import '~@assets/scss/officialSupport/_dimen.scss';

.page-layout {
  .nav-bar-placeholder {
    height: calc(44px + constant(safe-area-inset-top));
    height: calc(44px + env(safe-area-inset-top));
  }
  .nav-bar {
    ::v-deep .van-nav-bar {
      // 背景没有透明
      // background-position: 0 0;
      // background-size: 100% auto;
      // background-image: var(--menu-bg);
      // background-repeat: no-repeat;

      // 背景图片透明度
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        background-position: 0 0;
        background-size: 100% auto;
        background-image: var(--menu-bg);
        background-repeat: no-repeat;
        opacity: 0.5;
      }
    }
    ::v-deep .van-nav-bar__content {
      height: 44px;
    }
    ::v-deep .van-nav-bar__arrow {
      font-weight: bold;
      color: var(--back-color);
    }
    ::v-deep .van-nav-bar__title {
      font-size: 15px;
      color: var(--text-color);
    }
    &.hide-bg {
      ::v-deep .van-nav-bar {
        &::before {
          background: none;
        }
      }
    }
  }
  &.pc {
    &.create-work {
      .form {
        box-shadow: border-box;
        width: calc(100vw - $paddingWidth);
        max-width: $mainWidth;
      }
    }
    ::v-deep {
      .work-list {
        &-search {
          .search {
            box-sizing: border-box;
            width: 100%;
            // padding: 0 22px;
          }
        }
        &-main {
          box-sizing: border-box;
          // padding-left: 22px;
          // padding-right: 22px;
        }
        &-item {
          width: 100%;
        }
      }
      .title {
        gap: 22px;
        &-cont {
          width: 100%;
          /* 字号由 worklist / WorkItem / FaqItem 用 vw/vh 控制，避免固定 16px 被 PC scale 放大 */
          font-weight: bold;
        }
      }
      .reply {
        &-bottom {
          &-text {
            width: 100%;
          }
        }
      }
      .tabbar {
        .bottom-evaluate {
          width: calc(100vw - $paddingWidth);
          max-width: 681px;
        }
      }
      // .work-home-wrap,
      // .faq-list-wrap,
      // .faq-detail-wrap,
      // .work-temp-form,
      // .work-search-wrap {
      //   padding: 0 22px;
      // }
      .work-home-faq {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
      }
      .faq-notice-swipe {
        width: 90%;
      }
    }
  }

  @media screen and (orientation: landscape) {
    &.phone {
      .nav-bar {
        ::v-deep .van-nav-bar__title {
          font-size: 22px;
        }
        ::v-deep .lang-choose-select {
          font-size: 14px;
        }
        ::v-deep .van-badge__wrapper {
          font-size: 16px;
        }
      }
      ::v-deep {
        .work-list {
          &-search {
            .search {
              box-sizing: border-box;
              width: 100%;
              padding: 0 22px;
              .van-cell {
                font-size: 16px;
              }
            }
          }
          &-main {
            box-sizing: border-box;
            padding-left: 22px;
            padding-right: 22px;
          }
          &-item {
            width: 100%;
            .order-left,
            .title-date {
              font-size: 16px;
            }
          }
          &-create {
            &-btn {
              font-size: 20px;
            }
          }
        }

        .title {
          gap: 22px;
          &-cont {
            width: 100%;
            /* 字号由 worklist 等页面用 vh 控制，避免固定 20px 被放大 */
            font-weight: bold;
          }
        }
        .reply {
          font-size: 16px;
          &-bottom {
            &-text {
              width: 100%;
            }
          }
        }
        .tabbar {
          .bottom-evaluate {
            width: calc(100vw - $paddingWidth);
            max-width: 681px;
          }
          .bottom-bar-service,
          .bottom-bar-email {
            font-size: 14px;
          }
        }
        .work-home-wrap,
        .faq-list-wrap,
        .faq-detail-wrap,
        .work-temp-form,
        .work-search-wrap {
          padding: 0 22px;
        }
        .work-home-faq {
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
        }
        .faq-notice-swipe {
          width: 90%;
        }
      }
      .section-title {
        font-size: 20px;
      }
      .work-home-search {
        ::v-deep .van-cell {
          font-size: 16px;
        }
      }
      .work-temp {
        ::v-deep .van-button {
          font-size: 18px;
        }
      }
      .work-home-faq-item-text {
        font-size: 18px;
      }

      .faq-list-type-1 {
        ::v-deep .faq-list-title-text {
          font-size: 18px;
        }
        ::v-deep .van-tab__text {
          font-size: 18px;
        }

        ::v-deep .faq-list-type-2 .van-cell__title {
          span {
            font-size: 18px;
          }
        }
      }
      .message {
        .text {
          font-size: 17px;
        }
        &-item {
          ::v-deep .cont-id {
            font-size: 14px;
          }
          ::v-deep .cont-title {
            font-size: 18px;
          }
          ::v-deep .cont-msg {
            font-size: 18px;
          }
        }
      }
    }
  }
}
</style>
